/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Transcript_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Transcript Event {eventIndex}" |
*
* @param {Event_Transcript_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_transcript_aria_label = /** @type {((inputs: Event_Transcript_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Transcript_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Evenement de transcription ${i?.eventIndex}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Transkript Ereignis ${i?.eventIndex}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Trascrizione evento ${i?.eventIndex}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Транскрипт события ${i?.eventIndex}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Transcripción del evento ${i?.eventIndex}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件记录 ${i?.eventIndex}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`トランスクリプトイベント ${i?.eventIndex}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ट्रांसक्रिप्ट इवेंट ${i?.eventIndex}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Transcrição do evento ${i?.eventIndex}`)
	return /** @type {LocalizedString} */ (`Transcript Event ${i?.eventIndex}`)
});